module.exports = {
  __init__: [ 'modeling', 'bpmnUpdater' ],
  __depends__: [
    require(52),
    require(26),
    require(80),
    require(68),
    require(78),
    require(118),
    require(240),
    require(171),
    require(132),
    require(229),
    require(144),
    require(236)
  ],
  bpmnFactory: [ 'type', require(27) ],
  bpmnUpdater: [ 'type', require(29) ],
  elementFactory: [ 'type', require(30) ],
  modeling: [ 'type', require(31) ],
  layouter: [ 'type', require(28) ],
  connectionDocking: [ 'type', require(247) ]
};
